export default {
  install(Vue, options) {
    Vue.prototype.IMAGE_TARGET = {
      PRODUCT_LOGO_IMAGE: 'PRODUCT_LOGO_IMAGE'
    }
  }
}
